import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(input: string | Date) {
  const d = typeof input === 'string' ? new Date(input) : input
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}

export function readingTime(text: string | undefined | null) {
  if (!text) return 1
  const words = text.trim().split(/\s+/).length
  return Math.max(1, Math.round(words / 220))
}

// Canonical site URL. Always idukki.io regardless of deploy host so
// every <link rel="canonical">, JSON-LD @id, OG / Twitter URL and
// sitemap entry consolidates to one origin. Preview deploys still
// inherit the production canonicalisation — which is what we want for
// SEO + AI-citation: even a preview deployment's pages declare
// idukki.io as the single source of truth.
//
// NEXT_PUBLIC_SITE_URL is still honoured for local dev / staging where
// you genuinely need a different origin in the metadata.
export const CANONICAL_ORIGIN = 'https://idukki.io'

export function siteUrl() {
  const explicit = process.env.NEXT_PUBLIC_SITE_URL
  if (explicit) return explicit.replace(/\/+$/, '')
  return CANONICAL_ORIGIN
}

// Internal asset URL — used for OG-image fetches and similar where the
// resource must resolve against the currently-deployed host (preview
// or production). Different from siteUrl() which is canonical-only.
export function deployUrl() {
  const explicit = process.env.NEXT_PUBLIC_SITE_URL
  if (explicit) return explicit.replace(/\/+$/, '')
  if (process.env.VERCEL_ENV === 'production' && process.env.VERCEL_PROJECT_PRODUCTION_URL)
    return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
  if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`
  return CANONICAL_ORIGIN
}

export function absoluteUrl(path = '') {
  if (/^https?:\/\//i.test(path)) return path
  return `${siteUrl()}${path.startsWith('/') ? path : `/${path}`}`
}
